export {
  useActiveTyping,
  useActivities,
  useActivityKeys,
  useActivityKeysByRead,
  useAvatarForBot,
  useAvatarForUser,
  useBuildRenderActivityCallback,
  useByteFormatter,
  useCapabilities,
  useConnectivityStatus,
  useCreateActivityRenderer,
  useCreateActivityStatusRenderer,
  useCreateAttachmentForScreenReaderRenderer,
  useCreateAvatarRenderer,
  useCreateScrollToEndButtonRenderer,
  useDateFormatter,
  useDebouncedNotifications,
  useDictateInterims,
  useDictateState,
  useDirection,
  useDisabled,
  useDismissNotification,
  useEmitTypingIndicator,
  useGetActivitiesByKey,
  useGetActivityByKey,
  useGetHasAcknowledgedByActivityKey,
  useGetKeyByActivity,
  useGetKeyByActivityId,
  useGetSendTimeoutForActivity,
  useGrammars,
  useGroupActivities,
  useGroupActivitiesByName,
  useGroupTimestamp,
  useLanguage,
  useLastAcknowledgedActivityKey,
  useLastReadActivityKey,
  useLocalizer,
  useMarkActivityAsSpoken,
  useMarkActivityKeyAsRead,
  useMarkAllAsAcknowledged,
  useNotifications,
  usePerformCardAction,
  usePonyfill,
  usePostActivity,
  useReferenceGrammarID,
  useRelativeTimeFormatter,
  useRenderAttachment,
  useRenderToast,
  useRenderTypingIndicator,
  useSendBoxAttachments,
  useSendBoxValue,
  useSendEvent,
  useSendMessageBack,
  useSendPostBack,
  useSendStatusByActivityKey,
  useSendTimeoutForActivity,
  useSendTypingIndicator,
  useSetNotification,
  useShouldSpeakIncomingActivity,
  useStartDictate,
  useStartVoice,
  useStopDictate,
  useStopVoice,
  useStyleOptions,
  useSubmitSendBox,
  useSuggestedActions,
  useSuggestedActionsHooks,
  useTimeoutForSend,
  useTrackDimension,
  useTrackEvent,
  useTrackException,
  useTrackTiming,
  useUIState,
  useUserID,
  useUsername,
  useVoiceRecordingMuted,
  useVoiceSelector,
  useVoiceState
} from 'botframework-webchat-api/hook.js';

export { useFileDropZone, type DropZoneState } from '@msinternal/botframework-webchat-react-hooks';

// #region Overrides
export {
  // We are overwriting the `useSendFiles` hook from bf-wc-api and adding thumbnailing support.
  useSendFiles,
  // We are overwriting the `useSendMessage` hook from bf-wc-api and adding thumbnailing support.
  useSendMessage
} from '../hooks/index';
// #endregion

// #region Adds
export {
  useDictateAbortable,
  useFocus,
  useMakeThumbnail,
  useMicrophoneButtonClick,
  useMicrophoneButtonDisabled,
  useObserveScrollPosition,
  useObserveTranscriptFocus,
  useRegisterFocusSendBox,
  useRenderMarkdownAsHTML,
  useScrollDown,
  useScrollTo,
  useScrollToEnd,
  useScrollUp,
  useSendBoxSpeechInterimsVisible,
  useShouldReduceMotion,
  useStyleSet,
  useTextBoxSubmit,
  useTextBoxValue,
  useTransformHTMLContent,
  useTypingIndicatorVisible,
  useWebSpeechPonyfill,
  type SendBoxFocusOptions
} from '../hooks/index';
// #endregion
